import { getTokenDefinition } from "@bracket/chainography";
import { approve } from "@bracket/contractor-next/erc20";
import type { AmountString, BlockHash, TokenIdentifier, VaultAddress, } from "@bracket/types";
import { isUserWalletRejection, } from "@utils";
import { wagmiConfig as config } from "@wagmiconfig";



export declare type ApproveVaultSpendProps = {
	vault: VaultAddress;
	amount: AmountString;
	token: TokenIdentifier;
};


export declare type ApproveVaultSpendResult =
	| {
			success: true;
			hash: BlockHash;
	  }
	| {
			success: false;
			rejected: true;
	  }
	| {
			success: false;
			rejected: false;
			error: Error;
	  };



/**
 * Approves a vault to spend tokens on behalf of the user
 * @param {ApproveVaultSpendProps} props - The approval parameters
 * @param {VaultAddress} props.vault - The vault address to approve
 * @param {AmountString} props.amount - The amount to approve
 * @param {TokenIdentifier} props.token - The token identifier to approve
 * @returns {Promise<ApproveVaultSpendResult>} The result of the approval attempt
 */
export const approveVaultSpend = async ({
	vault,
	amount,
	token,
}: ApproveVaultSpendProps): Promise<ApproveVaultSpendResult> => {

	const tok = getTokenDefinition(token);

	try {

		const hash = await approve({
			token: tok,
			amount: BigInt(1e50), //bi(amount, token),
			spender: vault,
			config,
		});

		return {
			success: true,
			hash,
		};

	}
	catch (err) {

		if(isUserWalletRejection(err)) {

			return {
				success: false,
				rejected: true,
			};

		}

		return {
			success: false,
			rejected: false,
			error: err instanceof Error ? err : new Error("invalid error thrown"),
		};

	}

};
